import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from '../../utils/secureStorage';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  return getToken('accessToken') ? children : <Navigate to={`/login?l=${encodeURIComponent(location.pathname)}`} />;
};

export default PrivateRoute;
